import { Component, OnInit, HostBinding } from '@angular/core';
import { CartConfigService } from '../../services/cart-config/cart-config.service';
import { CartService } from '../../services/cart/cart.service';

@Component({
  selector: 'ags-cart-home-button',
  templateUrl: './cart-home-button.component.html',
  styleUrls: ['./cart-home-button.component.scss']
})
export class CartHomeButtonComponent implements OnInit {
  @HostBinding('class') themeFlag: string;
  linkToCart: string;
  cartCount = 0;

  constructor(private cartConfigService: CartConfigService, private cartService: CartService) {
    this.themeFlag = `${this.themeFlag || ''} ${cartConfigService.themingClassName} exported`;
  }

  async ngOnInit() {
    // le chargement de cartService est volontairement ralenti dans le constructor (cause: disponibilité de userConnected)
    // cartCount doit être placé à la fin pour l'affichage
    this.cartCount = this.cartService.getCartCount();
    this.cartService.resaListObservable().subscribe(list => {
      this.cartCount = list.length;
    });
    this.linkToCart = `/${this.cartConfigService.routingBaseUri}`;
  }
}
